import React from 'react';
import intl from 'react-intl-universal';
import { graphql, DataValue } from 'react-apollo';
import thirdPartyDevicesQuery from 'queries/roomSystems/thirdPartyDevicesQuery.gql';
import { ThirdPartyDevicesQuery } from 'typings/types';
import { exportToCsv } from 'utils/csv-utils';
import { parse220CredentialsForExport } from '../../../utils/exportUtils';
import * as styles from 'components/Settings/Sections.scss';

type Response = {
  get220DevicesByGroup: ThirdPartyDevicesQuery.Get220DevicesByGroup[];
};

interface Props {
  data?: DataValue<Response>;
}
class Downloads extends React.PureComponent<Props> {
  render() {
    const data = this.props.data;
    return (
      <section className={styles.container} data-test="settingsSection.downloads">
        <article>
          <h6 className={styles.title} data-test="sectionTitle">{intl.get('downloadsPageTitle')}</h6>
          <ul className={styles.linkList}>
            <li>
              <a href="https://download.lifesizecloud.com/download?platform=msi">
                {intl.get('downloadsWindowsInstallationPackage')}
              </a>
            </li>
            <li>
              <a href="https://download.lifesizecloud.com/download?platform=win">
                {intl.get('downloadsLifesizeAppForWindows')}
              </a>
            </li>
            <li>
              <a href="https://download.lifesizecloud.com/download?platform=osx">
                {intl.get('downloadsLifesizeAppForOSX')}
              </a>
            </li>
            {(data && data.get220DevicesByGroup && data.get220DevicesByGroup.length) ?
              <li>
                <a
                  onClick={
                    () => {
                      if (data && data.get220DevicesByGroup) {
                        const exportData = [];
                        for (let device of data.get220DevicesByGroup) {
                          exportData.push(parse220CredentialsForExport(device));
                        }
                        exportToCsv(intl.get('creds220'), exportData);
                      }
                    }
                  }
                >
                  {intl.get('creds220')}
                </a>
              </li> : null
            }
          </ul>
        </article>
        <article>
          <ul className={styles.linkList}>
            <li>
              {intl.getHTML('downloadsScheduleWithCalendars')}
            </li>
            <li>
              <a href="https://chrome.google.com/webstore/detail/lifesize/pkdaplneajgbalnnmaoflooakgijjkhc">
                {intl.getHTML('downloadsChromeExtension')}
              </a>
            </li>
            <li>
              <a href="https://appsource.microsoft.com/product/office/wa200000175" target={'_blank'}>
                {intl.getHTML('downloadsOutlookAddIn')}
              </a>
            </li>
          </ul>
        </article>
      </section>
    );
  }
}

export default graphql<{}, Response>(thirdPartyDevicesQuery, {
  options: { fetchPolicy: 'cache-and-network' },
})(Downloads);
